<template>
    <app-layout class="main">
        <div class="row panel-container">
            <transition name="bounce" mode="out-in">
                <panel v-if="message">
                    <h2 slot="header">E-pasta apstiprināšana</h2>
                    <p>{{message}}</p>
                    <div slot="footer" class="text-center" style="width:100%;">
                        <router-link v-if="status === 'fail'" :to="{ name: 'auth.verify.resend' }" class="button primary">Pārsūtīt jaunu apstiprinājumu</router-link>
                        <router-link v-if="code === 'auth.verification.verified'" :to="{ name: 'auth.login' }" class="button primary">Pierakstīties</router-link>
                    </div>
                </panel>
            </transition>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '../../../layouts/AppLayout'
    import Panel from '../../../components/Panel'
    import auth from '../../../api/auth'

    export default {

        name: 'verify',

        props: {
            'token': {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                message: null,
                status: null,
                code: null
            }
        },

        created() {
            auth.verify(this.token)
                .then(response => {
                    this.status = response.data.status;
                    this.message = response.data.message;
                    this.code = response.data.code;
                })
        },

        components: { AppLayout, Panel }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/auth/verification/Verify.vue